import * as Constants from '../constants';

import { useState } from 'react';

import Modal from "./UI/Modal";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Form, Button } from 'react-bootstrap';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

import classes from "./RendaFixaForm.module.css"

const RendaFixaForm = (props) => {
    let record = props.assets.filter((item) => item.id === props.active.id)[0];

    const [rowId,] = useState((props.active ? props.active.id : -1));
    const [title, setTitle] = useState(() => record ? record.title : "");
    const [maturity, setMaturity] = useState(() => record ? record.maturity : "");

    const [indexer, setIndexer] = useState(() => record ? record.indexer : 0);
    const [type, setType] = useState(() => record ? record.type : 0);

    const [quantity, setQuantity] = useState(() => record ? record.quantity : 0);
    const [invested, setInvested] = useState(() => record ? record.invested : 0);

    const [grossValue, setGrossValue] = useState(() => record ? record.grossValue : 0);
    const [netValue, setNetValue] = useState(() => record ? record.netValue : 0);

    const [taxes, setTaxes] = useState(() => record ? record.taxes : 0);

    const [grossProfit, setGrossProfit] = useState(() => record ? record.grossProfit : 0);
    const [netProfit, setNetProfit] = useState(() => record ? record.netProfit : 0);

    const addURL = `${Constants.ADD_FIXED_INCOME}`;
    const editURL = `${Constants.UPDATE_FIXED_INCOME}`;

    const submitAssetHandler = async (event) => {
        event.preventDefault();

        const assetData = {
            id: rowId,
            title: title,
            maturity: maturity,
            indexer: indexer,
            type: type,
            quantity: quantity,
            invested: invested,
            grossValue: grossValue,
            netValue: netValue,
            taxes: taxes,
            grossProfit: grossProfit,
            netProfit: netProfit
        };

        const url = (props.edit ? editURL : addURL);
        const token = localStorage.getItem("token");
        const response = await fetch(url, {
            method: props.method,
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(assetData)
        });
        props.onFinishSubmit(assetData);
    };

    return (
        <Modal modalClass={classes.modal} onClose={props.onClose}>
            <Form onSubmit={submitAssetHandler}>
                <Container>
                    <Row className='mt-1 mb-1'>
                        <Col xs={6}>
                            <Form.Group>
                                <Form.Label className="fw-bold">Título do Ativo:</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder="Ex: CDB Banco XP"
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3}>
                            <Form.Group>
                                <Form.Label className="fw-bold">Vencimento:</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={maturity}
                                    onChange={(e) => setMaturity(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3}>
                            <Form.Group>
                                <Form.Label className="fw-bold">Quantidade:</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.0001"
                                    value={quantity}
                                    onChange={(e) => setQuantity(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className='mb-1'>
                        <Col xs={3}>
                            <Form.Group>
                                <Form.Label className="fw-bold">Índice:</Form.Label>
                                <Form.Select
                                    value={indexer}
                                    onChange={(e) => setIndexer(e.target.value)}
                                >
                                    <option value="-1">Selecione</option>
                                    <option value="0">NENHUM</option>
                                    <option value="1">SELIC</option>
                                    <option value="2">IPCA</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col xs={3}>
                            <Form.Group>
                                <Form.Label className="fw-bold">Tipo:</Form.Label>
                                <Form.Select
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                >
                                    <option value="">Selecione</option>
                                    <option value="1">PÚBLICO</option>
                                    <option value="2">PRIVADO</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col xs={3}>
                            <Form.Group>
                                <Form.Label className="fw-bold">Valor Investido</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={invested}
                                    onChange={(e) => setInvested(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3} className='mb-1'>
                            <Form.Group>
                                <Form.Label className="fw-bold">Impostos:</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={taxes}
                                    onChange={(e) => setTaxes(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className='mb-1'>
                        <Col xs={3}>
                            <Form.Group>
                                <Form.Label className="fw-bold">Valor Bruto:</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={grossValue}
                                    onChange={(e) => setGrossValue(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3}>
                            <Form.Group>
                                <Form.Label className="fw-bold">Valor Líquido:</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={netValue}
                                    onChange={(e) => setNetValue(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3}>
                            <Form.Group>
                                <Form.Label className="fw-bold">Lucro Bruto:</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={grossProfit}
                                    onChange={(e) => setGrossProfit(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={3}>
                            <Form.Group>
                                <Form.Label className="fw-bold">Lucro Líquido:</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={netProfit}
                                    onChange={(e) => setNetProfit(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className='mb-2'>
                        <Col xs={12} className="text-end">
                            {props.edit &&
                                <Button variant="primary" type="submit">
                                    <FontAwesomeIcon icon={faFloppyDisk} />&nbsp;Editar
                                </Button>
                            }
                            {!props.edit &&
                                <Button variant="primary" type="submit">
                                    <FontAwesomeIcon icon={faFloppyDisk} />&nbsp;Adicionar
                                </Button>
                            }
                        </Col>
                    </Row>
                </Container>
            </Form>
        </Modal>
    );
};

export default RendaFixaForm;